import React, { useState, useEffect } from "react";
import Input from "./Input";
import useEmailValidation from "../../hooks/useEmailValidation";

const DynamicModal = ({
  heading,
  isModalOpen,
  id,
  setIsModalOpen,
  formData,
  handleInputChange,
  handleSave,
  fields,
  handleCloseModal
}) => {
  const [errors, setErrors] = useState({});
  const { emailError, setEmail } = useEmailValidation();

  // Validate a single field on input change
  const validateField = (name, value) => {
    const field = fields.find((field) => field.name === name);
    const newErrors = { ...errors };

    if (field.required && !value) {
      newErrors[name] = `${field.label} is required`;
    } else {
      delete newErrors[name];
    }

    // Email format validation
    if (name === "email") {
    const pattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!pattern.test(value)) {
      newErrors[name] = "Invalid email format.";
    }
  }

    setErrors(newErrors);
  };

  const handleFieldChange = (e) => {
    const { name, value, type, checked } = e.target;

    if (type === "radio") {
      handleInputChange({ target: { name, value: checked } });
    } else {
      handleInputChange(e);
    }

    validateField(name, value);
  };

  const handleFormSave = () => {
    const newErrors = {};
    fields.forEach((field) => {
      const value = formData[field.name];
      if (field.required && !value) {
        newErrors[field.name] = `${field.label} is required`;
      }

      // Re-check email format on save
      if (field.name === "email") {
        setEmail(value);
        if (value && emailError) {
          newErrors[field.name] = emailError;
        }
      }
    });

    if (Object.keys(newErrors).length === 0) {
      handleSave(formData);
      setIsModalOpen(false);
      handleCloseModal(false); // Close modal only if form is valid
    } else {
      setErrors(newErrors);
    }
  };

  useEffect(() => {
    if (!isModalOpen) {
      setErrors({});
    }
  }, [isModalOpen]);

  return (
    <>
      {isModalOpen && (
        <div
          className="modal fade modal-save-as show show-modal modal--opacity"
          id={id}
          data-bs-backdrop="static"
          data-bs-keyboard="false"
          tabIndex="-1"
          aria-labelledby="staticBackdropLabel"
          aria-hidden="true"
          style={{ display: "block" }}
        >
          <div className="modal-dialog modal-lg">
            <div className="modal-content">
              <div className="modal-header">
                <div className="modal-title fnt14 fw-500" id="staticBackdropLabel">
                  {heading}
                </div>
                <button
                  type="button"
                  className="btn-close px-1"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                  onClick={() => {
                    setIsModalOpen(false);
                    handleCloseModal(false);
                  }}
                ></button>
              </div>
              <div className="modal-body">
                <form>
                  <div className="row">
                    {fields.map((field) => (
                      <div className="col-6" key={field.id}>
                        <Input
                          type={field.type}
                          id={field.id}
                          name={field.name}
                          value={
                            field.type === "date" && formData[field.name]
                              ? new Date(formData[field.name])
                                .toISOString()
                                .split("T")[0]
                              : formData[field.name] || ""
                          }
                          onChange={handleFieldChange}
                          placeholder={field.placeholder}
                          label={field.label}
                          options={field.options}
                          checked={
                            field.type === "radio" &&
                            formData[field.name] === field.value
                          }
                        />
                        {errors[field.name] && (
                          <div className="text-danger fnt10 fw-500 error-message show">
                            {errors[field.name]}
                          </div>
                        )}
                      </div>
                    ))}
                  </div>
                </form>
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-secondary"
                  data-bs-dismiss="modal"
                  onClick={() => {
                    setIsModalOpen(false);
                    handleCloseModal(false);
                  }}
                >
                  Close
                </button>
                <button
                  type="button"
                  className="btn btn-primary"
                  onClick={handleFormSave}
                >
                  {id === 'new-user-form' ? 'Create' : 'Save changes'}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default DynamicModal;
